import { FlagsPermissionReport } from "@/feature-flags/flag-report";

const Layout = () =>
  import(/* webpackChunkName: "Layout" */ "@/app/ui/layout/index.vue");
const Report = () =>
  import(/* webpackChunkName: "Report" */ "@/app/ui/views/report/index.vue");

export default [
  {
    path: "/reports",
    component: Layout,
    name: "report",
    meta: {
      icon: "report",
      children: false,
      title: "report.title",
      name: "report.title",
      permission: [
        FlagsPermissionReport.laporan_download_stt,
        FlagsPermissionReport.laporan_download_stt_manual,
        FlagsPermissionReport.laporan_download_top_up,
        FlagsPermissionReport.laporan_download_shortland,
        FlagsPermissionReport.laporan_download_scrap,
        FlagsPermissionReport.laporan_download_referral_pos,
        FlagsPermissionReport.laporan_download_pengiriman_masuk,
        FlagsPermissionReport.laporan_download_pengiriman_keluar,
        FlagsPermissionReport.laporan_download_pengiriman,
        FlagsPermissionReport.laporan_download_pembatalan_stt,
        FlagsPermissionReport.laporan_download_misroute,
        FlagsPermissionReport.laporan_download_komisi_pos_induk,
        FlagsPermissionReport.laporan_download_komisi_pengiriman_tier_x,
        FlagsPermissionReport.laporan_download_komisi_pengiriman,
        FlagsPermissionReport.laporan_download_komisi_affiliate
      ]
    },
    children: [
      {
        path: "/reports",
        name: "Laporan",
        component: Report,
        meta: {
          header: true
        }
      }
    ]
  }
];
